/* ============================================================
   FIRST TASTE — global behavior. Vanilla JS, zero dependencies.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* safety net if the layout didn't define FT (e.g. gate page) */
  window.FT = window.FT || {};
  window.FT.routes = window.FT.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', cartGet: '/cart.js' };
  window.FT.routes.cartUpdate = window.FT.routes.cartUpdate || '/cart/update';
  window.FT.go = window.FT.go || function (url) { window.location.assign(url); };
  window.FT.money = window.FT.money || function (cents) { var d = cents % 100 === 0 ? 0 : 2; return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d }); };

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ---------------- pinch-zoom guard ----------------
     While the visual viewport is pinch-zoomed, every scroll-linked effect
     (header tuck, hero settle, dust reseeding) is paused so zooming in and
     out never tears the layout or fights the user's fingers. */
  var isZoomed = false;
  function initZoomGuard() {
    /* zoom is disabled: swallow iOS pinch gestures the meta tag can't stop */
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (ev) {
      doc.addEventListener(ev, function (e) { e.preventDefault(); }, { passive: false });
    });
    var vv = window.visualViewport;
    if (!vv) return;
    function check() {
      var z = vv.scale > 1.02;
      if (z !== isZoomed) {
        isZoomed = z;
        doc.documentElement.classList.toggle('is-zoomed', z);
      }
    }
    vv.addEventListener('resize', check, { passive: true });
    vv.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---------------- i18n ---------------- */
  var I18N = {
    es: {
      'skip': 'SALTAR AL CONTENIDO',
      'nav.home': 'INICIO', 'nav.reservations': 'RESERVAS', 'nav.vision': 'VISIÓN', 'nav.manifest': 'MANIFIESTO',
      'hero.scroll': 'DESLIZA', 'env.label': 'CÓMO FUNCIONA · ÁBREME',
      'count.days': 'DÍAS', 'count.hrs': 'HRS', 'count.min': 'MIN', 'count.sec': 'SEG',
      'guide.eyebrow': 'LÉEME', 'guide.title': 'Bienvenido a First Taste',
      'guide.intro': 'First Taste es una experiencia de cena-pasarela de aforo limitado en torno a la gastronomía, la moda y la vida nocturna. Cada capítulo es un evento de una sola noche con un nuevo escenario y una nueva experiencia.',
      'guide.res.h': 'RESERVAS',
      'guide.res.p1': 'Cada evento de First Taste es de una sola noche y aforo limitado. Las reservas se cierran cuando la sala está llena. Sin reserva no hay entrada.',
      'guide.res.chapter': 'Capítulo Uno: 10 de septiembre de 2026 en The Penthouse, 617 W 46th St, Hell’s Kitchen, NYC.',
      'guide.res.p2': 'Una reserva asegura tu asiento para la experiencia completa de cena-pasarela.',
      'guide.sec.h': 'COMPRA DE SECCIONES',
      'guide.sec.p1': 'Los invitados pueden reservar una sección entera de la mesa para su grupo. Ideal para fiestas, mesas de marca o grupos que quieren sentarse juntos. Hay extras disponibles, como el servicio de botellas. Contáctanos a través del sitio para disponibilidad de secciones y extras.',
      'guide.sub.h': 'SUSCRIPCIÓN',
      'guide.sub.p1': 'Para invitados que quieren acceso a los próximos capítulos de First Taste. Los suscriptores reciben acceso anticipado y novedades de cada capítulo. Los capítulos se publican periódicamente; suscribirte te ayuda a no perder ninguna ventana de reserva.',
      'guide.cta.reserve': 'VER RESERVAS', 'guide.cta.sub': 'SUSCRIBIRSE',
      'resv.eyebrow': 'CAPÍTULO UNO', 'resv.title': 'Reservas', 'resv.sub': 'ACCESO EXCLUSIVO. NOCHES INOLVIDABLES.',
      'offer.standing.title': 'Sala de pie.', 'offer.standing.cap': 'ENTRADA GENERAL',
      'offer.standing.note': 'Acceso a la sala durante toda la noche de cena-pasarela. Aforo limitado: la puerta se cierra cuando la sala está llena.',
      'cheph.optional': 'EXTRA OPCIONAL', 'cheph.name': 'APOYO CHEPHEW',
      'cheph.hint': 'apoya a la cocina detrás del capítulo. Se suma a la entrada.',
      'cheph.tip': '¡Todo ayuda!', 'cheph.clear': 'QUITAR APOYO',
      'cheph.modal.title': 'Apoyo Chephew', 'cheph.modal.sub': 'SE SUMA A TU ENTRADA',
      'cheph.modal.opt': 'APOYO', 'cheph.none': 'QUIZÁ LUEGO',
      'cheph.incart': 'EN TU CARRITO', 'cheph.held': 'TU ENTRADA ESTÁ DENTRO · ¿QUIERES AÑADIR APOYO?',
      'confirm.title.cheph': 'Gracias por tu apoyo.', 'spot.wait': 'La mesa está puesta. Espera a que terminemos de comer.',
      'offer.reserve.title': 'Reserva tu asiento.', 'offer.reserve.cap': 'RESERVA DE ASIENTO',
      'offer.reserve.note': 'Un asiento reservado en la mesa-pasarela: la cena completa, cada plato, cada look.',
      'offer.bottle.title': 'Servicio de botellas.', 'offer.bottle.cap': 'PARA LA SECCIÓN',
      'offer.bottle.note': 'Servido durante toda la noche por nuestro equipo de sala. Elige tu nivel.',
      'offer.sections.title': 'Secciones.', 'offer.sections.cap': 'TU PROPIO ESPACIO',
      'offer.sections.note': 'Una sección entera de la mesa para tu grupo: fiestas, mesas de marca o amigos que se sientan juntos.',
      'offer.diamond.title': 'Paquete Diamante.', 'offer.diamond.cap': 'LA EXPERIENCIA COMPLETA',
      'offer.diamond.note': 'Nuestro nivel más alto: los mejores asientos, servicio dedicado y una noche construida alrededor de tu grupo.',
      'vision.eyebrow': 'LA VISIÓN', 'vision.title': 'Una mesa para cada lenguaje.',
      'vision.p1': 'Cada forma de arte es un lenguaje: una manera de decir lo que las palabras no alcanzan. El mío es la comida. Para otros, es la moda, la música, el arte, el movimiento o formas que aún no hemos nombrado. La mayor parte del tiempo, estas expresiones actúan en salas separadas, para públicos separados, sin llegar a hablarse.',
      'vision.p2': 'First Taste existe para cambiar eso.',
      'vision.p3': 'Construimos una sola mesa y la tratamos como un recipiente: un lugar donde distintas expresiones pueden sentarse juntas y conversar de verdad, plato a plato, expresión a expresión.',
      'vision.p4': 'El Capítulo Uno es la prueba de concepto: gastronomía y moda compartiendo una mesa-pasarela en Nueva York. Es el primero de muchos capítulos, cada uno trayendo otro lenguaje a la mesa, hasta que la sala esté llena de voces que antes actuaban solas.',
      'footer.tag': 'Una experiencia de cena-pasarela de aforo limitado. Gastronomía, moda y vida nocturna en una sola mesa.',
      'footer.nav': 'NAVEGAR', 'footer.sub.h': 'SUSCRÍBETE · NO TE PIERDAS NINGÚN CAPÍTULO',
      'footer.sub.ok': 'ESTÁS EN LA LISTA · NOS VEMOS EN EL PRÓXIMO CAPÍTULO', 'footer.sub.ph': 'TU CORREO',
      'footer.sub.err': 'ESE CORREO NO PARECE VÁLIDO · INTÉNTALO DE NUEVO',
      'footer.sub.note': 'Acceso anticipado y novedades de nuevos capítulos. Los capítulos se publican periódicamente: suscribirte significa no perder ninguna ventana de reserva.',
      'confirm.eyebrow': 'FIRST TASTE · CONFIRMACIÓN', 'confirm.title': 'Tu asiento está reservado.',
      'confirm.sub': 'COMPLETA EL PAGO PARA GRABARLO EN EL MANIFIESTO',
      'confirm.more': 'OTRAS RESERVAS', 'confirm.checkout': 'IR AL PAGO',
      'cart.eyebrow': 'FIRST TASTE · CAPÍTULO UNO', 'cart.title': 'El Manifiesto', 'cart.remove': 'QUITAR',
      'cart.total': 'TOTAL · IMPUESTOS AL PAGAR', 'cart.update': 'ACTUALIZAR MANIFIESTO', 'cart.checkout': 'IR AL PAGO',
      'cart.empty': 'El manifiesto está vacío: la mesa sigue abierta.', 'cart.browse': 'VER RESERVAS',
      'pass.error': 'LA PUERTA NO RECONOCIÓ ESO · INTÉNTALO DE NUEVO', 'pass.placeholder': 'INTRODUCE LA CONTRASEÑA',
      'pass.hint': 'LA PUERTA ESTÁ ESCUCHANDO',
      'product.add': 'AÑADIR AL MANIFIESTO', 'product.soldout': 'AGOTADO',
      'product.note': 'El inventario es el aforo: cuando se acaba, la sala está llena.',
      'e404.line': 'Esta puerta no existe, pero la mesa está puesta.', 'e404.back': 'VOLVER A LA SALA',
      'search.title': 'Buscar', 'search.none': 'Nada en el manifiesto con ese nombre.',
      'toast.added': 'AÑADIDO AL MANIFIESTO', 'toast.unavailable': 'NO DISPONIBLE AHORA MISMO · INTÉNTALO DE NUEVO',
      'toast.cheph': 'APOYO CHEPHEW AÑADIDO', 'toast.removed': 'APOYO ELIMINADO', 'toast.err': 'ALGO FALLÓ · INTÉNTALO DE NUEVO',
      "add.label": "AÑADIR A LA MESA",
      "drawer.title": "Tu mesa",
      "drawer.items": "ARTÍCULOS",
      "drawer.empty": "Aún no hay nada reservado. La mesa sigue abierta.",
      "drawer.total": "TOTAL · IMPUESTOS AL PAGAR",
      "foyer.cta.reserve": "RESERVA TU ASIENTO",
      "foyer.cta.vision": "LA VISIÓN",
      "gate.enter": "ENTRAR",
      "return.label": "RESERVAS",
      "env.readme": "LÉEME",
      "add.standing": "AÑADIR ENTRADA",
      "add.table": "AÑADIR ASIENTO",
      "add.bottle": "AÑADIR SERVICIO DE BOTELLAS",
      "add.section": "AÑADIR SECCIÓN",
      "add.diamond": "AÑADIR PAQUETE DIAMANTE",
      "nav.spotlight": "EN ESCENA",
      "diet.title": "¿Alguna restricción alimentaria?",
      "diet.sub": "UNA NOTA PARA LA COCINA · SE GUARDA CON TU PEDIDO",
      "diet.ph": "ALERGIAS, PREFERENCIAS, LO QUE DEBAMOS SABER",
      "diet.skip": "SIN RESTRICCIONES",
      "spot.eyebrow": "LA OBRA",
      "spot.title": "Spotlight.",
      "spot.sub": "LAS MANOS DETRÁS DE LA NOCHE",
      "spot.chefs": "LOS CHEFS",
      "spot.models": "LAS MODELOS",
      "spot.stylists": "LOS ESTILISTAS",
      "spot.film": "LA PELÍCULA",
      "spot.soon": "Espera hasta después del show...",
      "spot.soonmicro": "ESPERA HASTA DESPUÉS DEL SHOW...",
      'standing.tier.admission': 'ENTRADA', 'standing.tier.entry': 'ACCESO', 'tier.soldout': 'AGOTADO', 'sections.tier.section': 'SECCIÓN', 'sections.tier.premier': 'SECCIÓN PREMIER', 'footer.chapter': 'CAPÍTULO UNO',
      'standing.total': 'TOTAL'
    },
    fr: {
      'skip': 'ALLER AU CONTENU',
      'nav.home': 'ACCUEIL', 'nav.reservations': 'RÉSERVATIONS', 'nav.vision': 'VISION', 'nav.manifest': 'MANIFESTE',
      'hero.scroll': 'FAITES DÉFILER', 'env.label': 'MODE D’EMPLOI · OUVREZ-MOI',
      'count.days': 'JOURS', 'count.hrs': 'H', 'count.min': 'MIN', 'count.sec': 'SEC',
      'guide.eyebrow': 'LISEZ-MOI', 'guide.title': 'Bienvenue chez First Taste',
      'guide.intro': 'First Taste est une expérience dîner-défilé à capacité limitée, autour de la gastronomie, de la mode et de la nuit. Chaque chapitre est un événement d’un soir, avec un nouveau décor et une nouvelle expérience.',
      'guide.res.h': 'RÉSERVATIONS',
      'guide.res.p1': 'Chaque événement First Taste dure une seule nuit, à capacité limitée. Les réservations ferment dès que la salle est pleine. Pas d’entrée sans réservation.',
      'guide.res.chapter': 'Chapitre Un : 10 septembre 2026 au Penthouse, 617 W 46th St, Hell’s Kitchen, NYC.',
      'guide.res.p2': 'Une réservation garantit votre place pour l’expérience dîner-défilé complète.',
      'guide.sec.h': 'ACHAT DE SECTIONS',
      'guide.sec.p1': 'Les invités peuvent réserver une section entière de la table pour leur groupe. Idéal pour les fêtes, les tables de marque ou les groupes qui veulent rester ensemble. Des options comme le service de bouteilles sont disponibles. Contactez-nous via le site pour la disponibilité des sections et les options.',
      'guide.sub.h': 'ABONNEMENT',
      'guide.sub.p1': 'Pour les invités qui veulent accéder aux prochains chapitres de First Taste. Les abonnés reçoivent un accès anticipé et les nouveautés de chaque chapitre. Les chapitres paraissent périodiquement : s’abonner, c’est ne jamais manquer une fenêtre de réservation.',
      'guide.cta.reserve': 'VOIR LES RÉSERVATIONS', 'guide.cta.sub': 'S’ABONNER',
      'resv.eyebrow': 'CHAPITRE UN', 'resv.title': 'Réservations', 'resv.sub': 'ACCÈS EXCLUSIF. NUITS INOUBLIABLES.',
      'offer.standing.title': 'Place debout.', 'offer.standing.cap': 'ENTRÉE GÉNÉRALE',
      'offer.standing.note': 'Accès à la salle pour toute la soirée dîner-défilé. Capacité limitée : la porte ferme quand la salle est pleine.',
      'cheph.optional': 'OPTION FACULTATIVE', 'cheph.name': 'SOUTIEN CHEPHEW',
      'cheph.hint': 'soutenez la cuisine derrière le chapitre. Ajouté en plus de l’entrée.',
      'cheph.tip': 'Chaque geste compte !', 'cheph.clear': 'RETIRER LE SOUTIEN',
      'cheph.modal.title': 'Soutien Chephew', 'cheph.modal.sub': 'AJOUTÉ À VOTRE ENTRÉE',
      'cheph.modal.opt': 'SOUTIEN', 'cheph.none': 'PEUT-ÊTRE PLUS TARD',
      'cheph.incart': 'DANS VOTRE PANIER', 'cheph.held': 'VOTRE ENTRÉE EST AJOUTÉE · SOUHAITEZ-VOUS AJOUTER UN SOUTIEN ?',
      'confirm.title.cheph': 'Merci pour votre soutien.', 'spot.wait': 'La table est dressée. Attendez la fin du repas.',
      'offer.reserve.title': 'Réservez votre place.', 'offer.reserve.cap': 'RÉSERVATION DE PLACE',
      'offer.reserve.note': 'Une place réservée à la table-podium : le dîner complet, chaque plat, chaque silhouette.',
      'offer.bottle.title': 'Service de bouteilles.', 'offer.bottle.cap': 'POUR LA SECTION',
      'offer.bottle.note': 'Servi toute la nuit par notre équipe de salle. Choisissez votre niveau.',
      'offer.sections.title': 'Sections.', 'offer.sections.cap': 'VOTRE PROPRE ESPACE',
      'offer.sections.note': 'Une section entière de la table pour votre groupe : fêtes, tables de marque ou amis qui restent ensemble.',
      'offer.diamond.title': 'Formule Diamant.', 'offer.diamond.cap': 'L\u2019EXPÉRIENCE COMPLÈTE',
      'offer.diamond.note': 'Notre niveau le plus haut : les meilleures places, un service dédié et une nuit construite autour de votre groupe.',
      'vision.eyebrow': 'LA VISION', 'vision.title': 'Une table pour chaque langage.',
      'vision.p1': 'Chaque forme d’art est un langage : une façon de dire ce que les mots n’atteignent pas. Le mien, c’est la cuisine. Pour d’autres, c’est la mode, la musique, l’art, le mouvement, ou des formes encore sans nom. La plupart du temps, ces expressions se produisent dans des salles séparées, pour des publics séparés, sans jamais vraiment se parler.',
      'vision.p2': 'First Taste existe pour changer cela.',
      'vision.p3': 'Nous dressons une seule table et la traitons comme un vaisseau : un lieu où différentes expressions peuvent s’asseoir ensemble et réellement dialoguer, plat après plat, expression après expression.',
      'vision.p4': 'Le Chapitre Un est la preuve du concept : gastronomie et mode partageant une même table-podium à New York. C’est le premier de nombreux chapitres, chacun apportant un nouveau langage à la table, jusqu’à ce que la salle soit pleine de voix qui, avant, se produisaient seules.',
      'footer.tag': 'Une expérience dîner-défilé à capacité limitée. Gastronomie, mode et nuit à une seule table.',
      'footer.nav': 'NAVIGUER', 'footer.sub.h': 'ABONNEZ-VOUS · NE MANQUEZ AUCUN CHAPITRE',
      'footer.sub.ok': 'VOUS ÊTES SUR LA LISTE · À BIENTÔT POUR LE PROCHAIN CHAPITRE', 'footer.sub.ph': 'VOTRE E-MAIL',
      'footer.sub.err': 'CET E-MAIL SEMBLE INVALIDE · RÉESSAYEZ',
      'footer.sub.note': 'Accès anticipé et nouveautés des chapitres. Les chapitres paraissent périodiquement : s’abonner, c’est ne jamais manquer une fenêtre de réservation.',
      'confirm.eyebrow': 'FIRST TASTE · CONFIRMATION', 'confirm.title': 'Votre place est retenue.',
      'confirm.sub': 'FINALISEZ LE PAIEMENT POUR LA GRAVER AU MANIFESTE',
      'confirm.more': 'AUTRES RÉSERVATIONS', 'confirm.checkout': 'PASSER AU PAIEMENT',
      'cart.eyebrow': 'FIRST TASTE · CHAPITRE UN', 'cart.title': 'Le Manifeste', 'cart.remove': 'RETIRER',
      'cart.total': 'TOTAL · TAXES AU PAIEMENT', 'cart.update': 'METTRE À JOUR', 'cart.checkout': 'PASSER AU PAIEMENT',
      'cart.empty': 'Le manifeste est vide. La table est encore ouverte.', 'cart.browse': 'VOIR LES RÉSERVATIONS',
      'pass.error': 'LA PORTE N’A PAS RECONNU CELA · RÉESSAYEZ', 'pass.placeholder': 'ENTREZ LE MOT DE PASSE',
      'pass.hint': 'LA PORTE ÉCOUTE',
      'product.add': 'AJOUTER AU MANIFESTE', 'product.soldout': 'ÉPUISÉ',
      'product.note': 'L’inventaire, c’est la capacité : quand il n’y en a plus, la salle est pleine.',
      'e404.line': 'Cette porte n’existe pas, mais la table est dressée.', 'e404.back': 'RETOUR À LA SALLE',
      'search.title': 'Recherche', 'search.none': 'Rien au manifeste à ce nom.',
      'toast.added': 'AJOUTÉ AU MANIFESTE', 'toast.unavailable': 'INDISPONIBLE POUR LE MOMENT · RÉESSAYEZ',
      'toast.cheph': 'SOUTIEN CHEPHEW AJOUTÉ', 'toast.removed': 'SOUTIEN RETIRÉ', 'toast.err': 'UNE ERREUR EST SURVENUE · RÉESSAYEZ',
      "add.label": "AJOUTER À LA TABLE",
      "drawer.title": "Votre table",
      "drawer.items": "ARTICLES",
      "drawer.empty": "Rien de retenu pour l’instant. La table est encore ouverte.",
      "drawer.total": "TOTAL · TAXES AU PAIEMENT",
      "foyer.cta.reserve": "RÉSERVEZ VOTRE PLACE",
      "foyer.cta.vision": "LA VISION",
      "gate.enter": "ENTRER",
      "return.label": "RÉSERVATIONS",
      "env.readme": "LISEZ-MOI",
      "add.standing": "AJOUTER L’ENTRÉE",
      "add.table": "AJOUTER UNE PLACE",
      "add.bottle": "AJOUTER LE SERVICE DE BOUTEILLES",
      "add.section": "AJOUTER LA SECTION",
      "add.diamond": "AJOUTER LA FORMULE DIAMANT",
      "nav.spotlight": "EN LUMIÈRE",
      "diet.title": "Des restrictions alimentaires ?",
      "diet.sub": "UNE NOTE POUR LA CUISINE · ENREGISTRÉE AVEC VOTRE COMMANDE",
      "diet.ph": "ALLERGIES, PRÉFÉRENCES, À NOUS SIGNALER",
      "diet.skip": "AUCUNE RESTRICTION",
      "spot.eyebrow": "L’ŒUVRE",
      "spot.title": "Spotlight.",
      "spot.sub": "LES MAINS DERRIÈRE LA NUIT",
      "spot.chefs": "LES CHEFS",
      "spot.models": "LES MANNEQUINS",
      "spot.stylists": "LES STYLISTES",
      "spot.film": "LE FILM",
      "spot.soon": "Attendez la fin du spectacle...",
      "spot.soonmicro": "ATTENDEZ LA FIN DU SPECTACLE...",
      'standing.tier.admission': 'ENTRÉE', 'standing.tier.entry': 'ACCÈS', 'tier.soldout': 'ÉPUISÉ', 'sections.tier.section': 'SECTION', 'sections.tier.premier': 'SECTION PREMIER', 'footer.chapter': 'CHAPITRE UN',
      'standing.total': 'TOTAL'
    },
    zh: {
      'skip': '跳到内容',
      'nav.home': '首页', 'nav.reservations': '预订', 'nav.vision': '愿景', 'nav.manifest': '清单',
      'hero.scroll': '向下滑动', 'env.label': '使用指南 · 点击打开',
      'count.days': '天', 'count.hrs': '时', 'count.min': '分', 'count.sec': '秒',
      'guide.eyebrow': '请阅读', 'guide.title': '欢迎来到 First Taste',
      'guide.intro': 'First Taste 是一场限量入场的“T台晚宴”体验，融合美食、时尚与夜生活。每一章都是一夜限定的活动，带来全新的场景与体验。',
      'guide.res.h': '预订',
      'guide.res.p1': '每场 First Taste 活动均为一夜限定、名额有限。满座后预订即关闭。谢绝无预订入场。',
      'guide.res.chapter': '第一章：2026年9月10日，The Penthouse，617 W 46th St，纽约地狱厨房。',
      'guide.res.p2': '预订即可确保您在整场T台晚宴中的座位。',
      'guide.sec.h': '整区购买',
      'guide.sec.p1': '宾客可为团体预订整段餐桌区域。适合派对、品牌桌或希望同坐的团体。另有瓶装酒水服务等加购项目。请通过本站联系我们了解区域余位与加购详情。',
      'guide.sub.h': '订阅',
      'guide.sub.p1': '面向希望参与未来章节的宾客。订阅者可获得优先购票与新章节动态。章节不定期发布，订阅让您不错过任何预订窗口。',
      'guide.cta.reserve': '查看预订', 'guide.cta.sub': '订阅',
      'resv.eyebrow': '第一章', 'resv.title': '预订', 'resv.sub': '专属通道，难忘之夜。',
      'offer.standing.title': '站席。', 'offer.standing.cap': '普通入场',
      'offer.standing.note': '全程参与T台晚宴之夜。名额有限，满座即止。',
      'cheph.optional': '可选加购', 'cheph.name': 'CHEPHEW 支持',
      'cheph.hint': '支持本章背后的厨房。将叠加在门票之上。',
      'cheph.tip': '涓滴皆助！', 'cheph.clear': '移除支持',
      'cheph.modal.title': 'Chephew 支持', 'cheph.modal.sub': '将叠加在您的门票上',
      'cheph.modal.opt': '支持', 'cheph.none': '稍后再说',
      'cheph.incart': '已在购物车', 'cheph.held': '门票已加入 · 要添加支持吗？',
      'confirm.title.cheph': '感谢您的支持。', 'spot.wait': '餐桌已备好。请等我们用餐结束。',
      'offer.reserve.title': '预留座位。', 'offer.reserve.cap': '座位预订',
      'offer.reserve.note': 'T台餐桌上的专属座位：完整晚宴、每道菜、每个造型。',
      'offer.bottle.title': '瓶装酒水服务。', 'offer.bottle.cap': '为您的专区',
      'offer.bottle.note': '由现场团队整晚为您斟酒。请选择级别。',
      'offer.sections.title': '整区。', 'offer.sections.cap': '专属于你的空间',
      'offer.sections.note': '为您的团体预留整段餐桌：派对、品牌桌或同坐的朋友。',
      'offer.diamond.title': '钻石套餐。', 'offer.diamond.cap': '完整体验',
      'offer.diamond.note': '最高级别：最佳座位、专属服务，为您的宾客量身打造整晚体验。',
      'vision.eyebrow': '愿景', 'vision.title': '一张容纳所有语言的餐桌。',
      'vision.p1': '每种艺术形式都是一种语言：诉说言语无法抵达之处。我的语言是美食。对其他人而言，是时尚、音乐、艺术、舞蹈，或尚未命名的形式。多数时候，这些表达在各自的房间里、面向各自的观众演出，彼此从未真正对话。',
      'vision.p2': 'First Taste 的存在，就是为了改变这一点。',
      'vision.p3': '我们搭起一张桌子，把它当作一艘容器：让不同的表达坐到一起，一道菜接一道菜、一种表达接一种表达地真正对话。',
      'vision.p4': '第一章是概念的证明：美食与时尚，在纽约共享一张T台晚宴长桌。这是众多章节的开端，每一章都将新的语言带上餐桌，直到满室都是曾经独自演出的声音。',
      'footer.tag': '限量入场的T台晚宴体验。美食、时尚与夜生活，同在一桌。',
      'footer.nav': '导航', 'footer.sub.h': '订阅 · 不错过任何一章',
      'footer.sub.ok': '您已在名单上 · 下一章见', 'footer.sub.ph': '您的邮箱',
      'footer.sub.err': '邮箱格式有误 · 请重试',
      'footer.sub.note': '优先购票与新章节动态。章节不定期发布，订阅意味着不错过任何预订窗口。',
      'confirm.eyebrow': 'FIRST TASTE · 确认', 'confirm.title': '座位已为您保留。',
      'confirm.sub': '完成结账，将其刻入清单',
      'confirm.more': '其他预订', 'confirm.checkout': '前往结账',
      'cart.eyebrow': 'FIRST TASTE · 第一章', 'cart.title': '清单', 'cart.remove': '移除',
      'cart.total': '合计 · 税费于结账时结算', 'cart.update': '更新清单', 'cart.checkout': '前往结账',
      'cart.empty': '清单还是空的，餐桌仍然开放。', 'cart.browse': '查看预订',
      'pass.error': '门没有认出它 · 请再试一次', 'pass.placeholder': '输入密码',
      'pass.hint': '门在倾听',
      'product.add': '加入清单', 'product.soldout': '售罄',
      'product.note': '库存即容量：售罄之时，便是满座之刻。',
      'e404.line': '这扇门并不存在，但餐桌已经摆好。', 'e404.back': '回到大厅',
      'search.title': '搜索', 'search.none': '清单上没有这个名字。',
      'toast.added': '已加入清单', 'toast.unavailable': '暂时无法购买 · 请稍后再试',
      'toast.cheph': '已添加 CHEPHEW 支持', 'toast.removed': '已移除支持', 'toast.err': '出了点问题 · 请重试',
      "add.label": "加入餐桌",
      "drawer.title": "您的餐桌",
      "drawer.items": "项",
      "drawer.empty": "尚未选择任何项目。餐桌仍然开放。",
      "drawer.total": "合计 · 税费结账时结算",
      "foyer.cta.reserve": "预留座位",
      "foyer.cta.vision": "愿景",
      "gate.enter": "进入",
      "return.label": "预订",
      "env.readme": "请阅读",
      "add.standing": "添加站席",
      "add.table": "添加座位",
      "add.bottle": "添加瓶装酒水服务",
      "add.section": "添加整区",
      "add.diamond": "添加钻石套餐",
      "nav.spotlight": "聚光灯",
      "diet.title": "有任何饮食禁忌吗？",
      "diet.sub": "给厨房的备注 · 随订单保存",
      "diet.ph": "过敏、偏好或其他需要我们知道的",
      "diet.skip": "无禁忌",
      "spot.eyebrow": "幕后",
      "spot.title": "聚光灯。",
      "spot.sub": "夜晚背后的双手",
      "spot.chefs": "主厨",
      "spot.models": "模特",
      "spot.stylists": "造型师",
      "spot.film": "影片",
      "spot.soon": "请等到演出结束……",
      "spot.soonmicro": "请等到演出结束……",
      'standing.tier.admission': '入场', 'standing.tier.entry': '基础入场', 'tier.soldout': '售罄', 'sections.tier.section': '专区', 'sections.tier.premier': '尊享专区', 'footer.chapter': '第一章',
      'standing.total': '合计'
    },
    ja: {
      'skip': 'コンテンツへ',
      'nav.home': 'ホーム', 'nav.reservations': '予約', 'nav.vision': 'ビジョン', 'nav.manifest': 'マニフェスト',
      'hero.scroll': 'スクロール', 'env.label': 'ご利用方法 · 開いてください',
      'count.days': '日', 'count.hrs': '時間', 'count.min': '分', 'count.sec': '秒',
      'guide.eyebrow': 'お読みください', 'guide.title': 'First Taste へようこそ',
      'guide.intro': 'First Taste は、食・ファッション・ナイトライフを軸にした少人数制のランウェイディナー体験です。各章は一夜限りのイベントで、毎回新しい舞台と体験をお届けします。',
      'guide.res.h': '予約',
      'guide.res.p1': 'First Taste のイベントはすべて一夜限り・定員制です。満席になり次第、予約は締め切られます。当日入場はできません。',
      'guide.res.chapter': '第一章：2026年9月10日、The Penthouse（617 W 46th St、ヘルズ・キッチン、NYC）にて。',
      'guide.res.p2': 'ご予約で、ランウェイディナー体験のすべてを通しでお席が確保されます。',
      'guide.sec.h': 'セクション購入',
      'guide.sec.p1': 'グループでテーブルのセクションを丸ごと予約いただけます。パーティー、ブランドテーブル、一緒に座りたいグループに最適です。ボトルサービスなどの追加オプションもございます。空き状況とオプションはサイトからお問い合わせください。',
      'guide.sub.h': 'サブスクリプション',
      'guide.sub.p1': '今後の章に参加したい方のために。登録者には先行アクセスと新章のお知らせをお届けします。章は不定期に公開されるため、登録しておけば予約の機会を逃しません。',
      'guide.cta.reserve': '予約を見る', 'guide.cta.sub': '登録する',
      'resv.eyebrow': '第一章', 'resv.title': '予約', 'resv.sub': '特別なアクセスを。忘れられない夜を。',
      'offer.standing.title': 'スタンディング。', 'offer.standing.cap': '一般入場',
      'offer.standing.note': 'ランウェイディナーの一夜をまるごと体験。定員制。満員になり次第、扉は閉まります。',
      'cheph.optional': '任意アドオン', 'cheph.name': 'CHEPHEW サポート',
      'cheph.hint': 'この章を支えるキッチンを応援。入場料に追加されます。',
      'cheph.tip': 'どんな支援も力になります！', 'cheph.clear': 'サポートを外す',
      'cheph.modal.title': 'Chephew サポート', 'cheph.modal.sub': '入場料に追加されます',
      'cheph.modal.opt': 'サポート', 'cheph.none': 'また今度',
      'cheph.incart': 'カートに追加済み', 'cheph.held': 'エントリーを追加しました · サポートも追加しますか？',
      'confirm.title.cheph': 'ご支援ありがとうございます。', 'spot.wait': 'テーブルは整いました。食事が終わるまでお待ちください。',
      'offer.reserve.title': 'お席の予約。', 'offer.reserve.cap': 'お席の予約',
      'offer.reserve.note': 'ランウェイテーブルの確約席。フルコース、すべての皿、すべてのルックを。',
      'offer.bottle.title': 'ボトルサービス。', 'offer.bottle.cap': 'セクションのために',
      'offer.bottle.note': 'フロアチームが一晩を通してサーブします。ティアをお選びください。',
      'offer.sections.title': 'セクション。', 'offer.sections.cap': 'あなただけの空間',
      'offer.sections.note': 'グループのためにテーブルのセクションを丸ごと。パーティー、ブランドテーブル、一緒に座る仲間に。',
      'offer.diamond.title': 'ダイヤモンドパッケージ。', 'offer.diamond.cap': 'コンプリート体験',
      'offer.diamond.note': '最高ティア。最良の席、専属サービス、あなたのパーティーを中心に組み立てる一夜。',
      'vision.eyebrow': 'ビジョン', 'vision.title': 'あらゆる言語のためのテーブル。',
      'vision.p1': 'すべての芸術は言語。言葉では届かない何かを語る方法です。私の言語は料理。ある人にとってはファッション、音楽、アート、ダンス、まだ名前のない表現かもしれません。多くの場合、これらの表現は別々の部屋で、別々の観客に向けて演じられ、互いに語り合うことはありません。',
      'vision.p2': 'First Taste は、それを変えるために存在します。',
      'vision.p3': '私たちは一つのテーブルを据え、それを器として扱います。異なる表現が同じ席に着き、一皿ごと、一つの表現ごとに、本当の対話を交わせる場所です。',
      'vision.p4': '第一章はその実証。食とファッションが、ニューヨークで一つのランウェイディナーテーブルを分かち合います。これは数ある章の最初の一つ。章を重ねるたびに新しい言語がテーブルに加わり、かつて独りで演じていた声で部屋が満ちるまで続きます。',
      'footer.tag': '少人数制のランウェイディナー体験。食、ファッション、ナイトライフを一つのテーブルで。',
      'footer.nav': 'メニュー', 'footer.sub.h': '登録 · どの章も見逃さない',
      'footer.sub.ok': 'リストに登録されました。次章でお会いしましょう', 'footer.sub.ph': 'メールアドレス',
      'footer.sub.err': 'メールアドレスをご確認ください。もう一度お試しを',
      'footer.sub.note': '先行アクセスと新章のお知らせ。章は不定期公開。登録しておけば予約の機会を逃しません。',
      'confirm.eyebrow': 'FIRST TASTE · 確認', 'confirm.title': 'お席を確保しました。',
      'confirm.sub': 'チェックアウトを完了してマニフェストに刻んでください',
      'confirm.more': '他の予約を見る', 'confirm.checkout': 'チェックアウトへ',
      'cart.eyebrow': 'FIRST TASTE · 第一章', 'cart.title': 'マニフェスト', 'cart.remove': '削除',
      'cart.total': '合計 · 税はチェックアウト時に', 'cart.update': '更新する', 'cart.checkout': 'チェックアウトへ',
      'cart.empty': 'マニフェストは空です。テーブルはまだ開いています。', 'cart.browse': '予約を見る',
      'pass.error': '扉はそれを認識しませんでした。もう一度どうぞ', 'pass.placeholder': 'パスワードを入力',
      'pass.hint': '扉は聞いています',
      'product.add': 'マニフェストに追加', 'product.soldout': '完売',
      'product.note': '在庫は定員。なくなれば満席です。',
      'e404.line': 'この扉は存在しません。でもテーブルは整っています。', 'e404.back': '会場へ戻る',
      'search.title': '検索', 'search.none': 'その名前はマニフェストにありません。',
      'toast.added': 'マニフェストに追加しました', 'toast.unavailable': 'ただいまご利用いただけません · もう一度お試しください',
      'toast.cheph': 'CHEPHEW サポートを追加しました', 'toast.removed': 'サポートを外しました', 'toast.err': 'エラーが発生しました · もう一度お試しください',
      "add.label": "テーブルに追加",
      "drawer.title": "あなたのテーブル",
      "drawer.items": "点",
      "drawer.empty": "まだ何もありません。テーブルはまだ開いています。",
      "drawer.total": "合計 · 税はチェックアウト時に",
      "foyer.cta.reserve": "席を予約する",
      "foyer.cta.vision": "ビジョン",
      "gate.enter": "入場",
      "return.label": "予約",
      "env.readme": "お読みください",
      "add.standing": "スタンディングを追加",
      "add.table": "席を追加",
      "add.bottle": "ボトルサービスを追加",
      "add.section": "セクションを追加",
      "add.diamond": "ダイヤモンドパッケージを追加",
      "nav.spotlight": "スポットライト",
      "diet.title": "食事制限はありますか？",
      "diet.sub": "キッチンへのメモ · ご注文と一緒に保存されます",
      "diet.ph": "アレルギーやご希望など",
      "diet.skip": "制限なし",
      "spot.eyebrow": "舞台裏",
      "spot.title": "スポットライト。",
      "spot.sub": "夜を支える手たち",
      "spot.chefs": "シェフ",
      "spot.models": "モデル",
      "spot.stylists": "スタイリスト",
      "spot.film": "フィルム",
      "spot.soon": "ショーが終わるまでお待ちください…",
      "spot.soonmicro": "ショーが終わるまでお待ちください…",
      'standing.tier.admission': '入場', 'standing.tier.entry': 'エントリー', 'tier.soldout': '完売', 'sections.tier.section': 'セクション', 'sections.tier.premier': 'プレミアセクション', 'footer.chapter': '第一章',
      'standing.total': '合計'
    }
  };

  var LANG_STORE = 'ft-lang';
  var currentLang = 'en';
  var originals = null;

  function cacheOriginals() {
    if (originals) return;
    originals = new Map();
    $$('[data-i18n]').forEach(function (el) { originals.set(el, el.textContent); });
    $$('[data-i18n-ph]').forEach(function (el) { originals.set(el, el.getAttribute('placeholder') || ''); });
  }

  function t(key) {
    if (currentLang === 'en') return null;
    var d = I18N[currentLang];
    return d ? d[key] : null;
  }
  function tOr(key, fallback) { return t(key) || fallback; }

  function applyLang(lang) {
    cacheOriginals();
    currentLang = lang;
    var dict = I18N[lang];
    $$('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      var val = lang === 'en' ? originals.get(el) : (dict && dict[key]);
      if (val != null) el.textContent = val;
    });
    $$('[data-i18n-ph]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-ph');
      var val = lang === 'en' ? originals.get(el) : (dict && dict[key]);
      if (val != null) el.setAttribute('placeholder', val);
    });
    doc.documentElement.setAttribute('lang', lang === 'zh' ? 'zh-CN' : lang);
    var cur = $('[data-lang-current]');
    if (cur) cur.textContent = lang.toUpperCase();
    $$('.ft-lang__opt').forEach(function (o) {
      o.setAttribute('aria-current', o.getAttribute('data-lang') === lang ? 'true' : 'false');
    });
    try { localStorage.setItem(LANG_STORE, lang); } catch (e) { /* private mode */ }
  }

  function initLang() {
    var saved = 'en';
    try { saved = localStorage.getItem(LANG_STORE) || 'en'; } catch (e) { /* noop */ }
    if (saved !== 'en' && I18N[saved]) applyLang(saved);
    else applyLang('en');

    var wrap = $('#ft-lang');
    if (!wrap) return;
    var btn = $('.ft-lang__btn', wrap);
    on(btn, 'click', function () {
      var open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('.ft-lang__opt', wrap).forEach(function (opt) {
      on(opt, 'click', function () {
        applyLang(opt.getAttribute('data-lang'));
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
    on(doc, 'click', function (e) {
      if (!wrap.contains(e.target)) { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape') { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------------- header + scroll choreography ---------------- */
  function initHeader() {
    var header = $('#ft-header');
    if (!header) return;
    var last = -1, lastY = window.scrollY, tucked = false, ticking = false;
    var heroInner = $('[data-hero-inner]');
    var resv = doc.getElementById('reservations');
    var vis = doc.getElementById('vision');
    var navHome = null, navResv = null, navVis = null;
    $$('.ft-nav__link').forEach(function (l) {
      var sc = l.getAttribute('data-scrollto');
      if (sc === 'reservations') navResv = l;
      else if (sc === 'vision') navVis = l;
      else if (!navHome && (l.getAttribute('href') || '').indexOf('spotlight') === -1) navHome = l;
    });
    function overlaysOpen() {
      return doc.querySelector('.ft-modal.is-open, .ft-drawer.is-open, .ft-confirm.is-open, .ft-nav.is-open');
    }
    function frame() {
      ticking = false;
      /* a pinch-zoomed viewport gets no scroll choreography at all */
      if (isZoomed) {
        if (tucked) { tucked = false; header.classList.remove('is-tucked'); }
        lastY = window.scrollY;
        return;
      }
      var y = window.scrollY;
      var sc = y > 12;
      if (sc !== last) { header.classList.toggle('is-scrolled', sc); last = sc; }
      /* tuck away going down, glide back going up — never while an overlay is open */
      var goingDown = y > lastY + 4;
      var goingUp = y < lastY - 4;
      if (!overlaysOpen() && !glideRaf) {
        if (goingDown && y > 320 && !tucked) { tucked = true; header.classList.add('is-tucked'); }
        else if ((goingUp || y < 320) && tucked) { tucked = false; header.classList.remove('is-tucked'); }
      } else if (tucked) { tucked = false; header.classList.remove('is-tucked'); }
      lastY = y;
      /* hero settles back as you scroll into the room */
      if (heroInner && !reduceMotion) {
        var vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, y / (vh * 0.9)));
        heroInner.style.transform = 'translateY(' + (p * -34).toFixed(1) + 'px) scale(' + (1 - p * 0.025).toFixed(4) + ')';
        heroInner.style.opacity = (1 - p * 0.55).toFixed(3);
      }
      /* scrollspy: HOME / RESERVATIONS / VISION */
      if (resv && navHome && navResv) {
        var r = resv.getBoundingClientRect();
        if (!(r.width === 0 && r.height === 0)) {
          var vh2 = window.innerHeight;
          var inVis = false;
          if (vis && navVis) {
            var rv = vis.getBoundingClientRect();
            inVis = rv.top < vh2 * 0.5 && rv.bottom > vh2 * 0.25;
          }
          var inResv = !inVis && r.top < vh2 * 0.5 && r.bottom > vh2 * 0.25;
          if (navVis) navVis.classList.toggle('is-active', inVis);
          navResv.classList.toggle('is-active', inResv);
          navHome.classList.toggle('is-active', !inVis && !inResv && r.top >= vh2 * 0.5);
        }
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }
    on(window, 'scroll', onScroll, { passive: true });
    on(doc, 'ft:overlay', function () {
      if (tucked) { tucked = false; header.classList.remove('is-tucked'); }
    });
    frame();

    var burger = $('#ft-burger');
    var nav = $('#ft-nav');
    if (burger && nav) {
      on(burger, 'click', function () {
        var open = nav.classList.toggle('is-open');
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        doc.documentElement.style.overflow = open ? 'hidden' : '';
      });
      $$('.ft-nav__link', nav).forEach(function (l) {
        on(l, 'click', function () {
          nav.classList.remove('is-open');
          burger.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
          doc.documentElement.style.overflow = '';
        });
      });
    }
  }

  /* ---------------- eased scroll — one clean glide ---------------- */
  var glideRaf = null;
  function glideTo(targetY) {
    if (reduceMotion) { window.scrollTo(0, targetY); return; }
    if (glideRaf) cancelAnimationFrame(glideRaf);
    var startY = window.scrollY;
    var dist = targetY - startY;
    if (Math.abs(dist) < 2) return;
    var dur = Math.min(320, 140 + Math.abs(dist) * 0.05);
    var t0 = null;
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      window.scrollTo(0, startY + dist * ease(p));
      if (p < 1) glideRaf = requestAnimationFrame(step);
      else glideRaf = null;
    }
    glideRaf = requestAnimationFrame(step);
  }
  /* a nudge from the user cancels the glide — never fight the wheel */
  ['wheel', 'touchstart'].forEach(function (ev) {
    doc.addEventListener(ev, function () { if (glideRaf) { cancelAnimationFrame(glideRaf); glideRaf = null; } }, { passive: true });
  });
  function scrollToId(id) {
    var el = doc.getElementById(id);
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return false;
    glideTo(r.top + window.scrollY - 46);
    /* content-visibility can shift layout once the target renders —
       re-measure after the glide and correct any drift */
    setTimeout(function () {
      if (glideRaf) return;
      var r2 = el.getBoundingClientRect();
      if (Math.abs(r2.top - 46) > 24) window.scrollTo(0, r2.top + window.scrollY - 46);
    }, 700);
    return true;
  }
  function initScrollLinks() {
    $$('[data-scrollto]').forEach(function (el) {
      on(el, 'click', function (e) {
        var id = el.getAttribute('data-scrollto');
        if (scrollToId(id)) {
          e.preventDefault();
          if (id === 'ft-subscribe') {
            var em = $('#ft-sub-email');
            if (em) setTimeout(function () { em.focus({ preventScroll: true }); }, 650);
          }
        }
      });
    });
    if (location.hash.length > 1) {
      var id = location.hash.slice(1);
      setTimeout(function () { scrollToId(id); }, 60);
    }
  }

  /* ---------------- reveals ---------------- */
  function initReveals() {
    var els = $$('.ft-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px 18% 0px', threshold: 0.01 });
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---------------- countdown ---------------- */
  function initCountdown() {
    var nodes = $$('[data-countdown]');
    if (!nodes.length) return;
    nodes.forEach(function (node) {
      var deadline = new Date(node.getAttribute('data-deadline') || '').getTime();
      if (isNaN(deadline)) return;
      var dEl = $('[data-cd-d]', node), hEl = $('[data-cd-h]', node),
          mEl = $('[data-cd-m]', node), sEl = $('[data-cd-s]', node);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          node.classList.add('is-done');
          node.textContent = '';
          var done = doc.createElement('p');
          done.className = 'ft-count__done';
          done.textContent = node.getAttribute('data-done-text') || 'DOORS OPEN';
          node.appendChild(done);
          clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff % 86400000 / 3600000);
        var m = Math.floor(diff % 3600000 / 60000);
        var s = Math.floor(diff % 60000 / 1000);
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------------- modals ---------------- */
  var openModal = null;
  var lastFocus = null;
  function modalOpen(id, trigger) {
    var m = doc.getElementById(id);
    if (!m) return;
    doc.dispatchEvent(new CustomEvent('ft:overlay'));
    lastFocus = trigger || doc.activeElement;
    doc.dispatchEvent(new CustomEvent('ft:modalopen', { detail: { id: id, modal: m } }));
    m.hidden = false;
    openModal = m;
    /* a store reply can beat the next frame — only settle open if nothing closed it since */
    requestAnimationFrame(function () { if (openModal === m) m.classList.add('is-open'); });
    doc.documentElement.style.overflow = 'hidden';
    var card = $('.ft-modal__card, .ft-confirm__card', m);
    if (card) setTimeout(function () { card.focus({ preventScroll: true }); }, 60);
  }
  function modalClose() {
    if (!openModal) return;
    var m = openModal;
    openModal = null;
    m.classList.remove('is-open');
    doc.documentElement.style.overflow = '';
    setTimeout(function () { m.hidden = true; }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    doc.dispatchEvent(new CustomEvent('ft:modalclose', { detail: { id: m.id, modal: m } }));
  }
  function initModals() {
    $$('[data-modal-open]').forEach(function (btn) {
      on(btn, 'click', function () { modalOpen(btn.getAttribute('data-modal-open'), btn); });
    });
    on(doc, 'click', function (e) {
      var closer = e.target.closest('[data-modal-close], [data-confirm-close]');
      if (closer) { modalClose(); confirmClose(); }
    });
    on(doc, 'keydown', function (e) {
      if (e.key === 'Escape') { modalClose(); confirmClose(); }
      if (e.key === 'Tab' && openModal) {
        var focusables = $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', openModal)
          .filter(function (el) { return el.offsetParent !== null; });
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && doc.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && doc.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    });
  }

  /* ---------------- toast ---------------- */
  var toastTimer = null;
  function toast(msg) {
    var el = $('#ft-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-in'); }, 3400);
  }

  /* ---------------- confirmation overlay ---------------- */
  function confirmClose() {
    var c = $('#ft-confirm');
    if (!c || c.hidden) return;
    c.classList.remove('is-open');
    c.setAttribute('data-closing', '');
    doc.documentElement.style.overflow = '';
    setTimeout(function () { if (c.hasAttribute('data-closing')) c.hidden = true; }, 420);
  }
  function confirmShow(lines, kind) {
    var c = $('#ft-confirm');
    if (!c) return;
    doc.dispatchEvent(new CustomEvent('ft:overlay'));
    /* "Your seat is held." for admission; "Thank you for the support." when
       only a Chephew line landed */
    kind = kind || 'seat';
    var dialog = $('.ft-confirm__card', c);
    $$('[data-confirm-title]', c).forEach(function (h) {
      var mine = h.getAttribute('data-confirm-title') === kind;
      h.hidden = !mine;
      if (mine && dialog && h.id) dialog.setAttribute('aria-labelledby', h.id);
    });
    var list = $('[data-confirm-lines]', c);
    if (list) {
      list.textContent = '';
      lines.forEach(function (ln) {
        var li = doc.createElement('li');
        var name = doc.createElement('span');
        name.textContent = ln.title;
        var price = doc.createElement('span');
        price.className = 'p';
        price.textContent = ln.price;
        li.appendChild(name); li.appendChild(price);
        list.appendChild(li);
      });
    }
    c.hidden = false;
    c.removeAttribute('data-closing');
    requestAnimationFrame(function () { if (!c.hidden && !c.hasAttribute('data-closing')) c.classList.add('is-open'); });
    doc.documentElement.style.overflow = 'hidden';
    if (dialog) setTimeout(function () { dialog.focus({ preventScroll: true }); }, 60);
  }
  /* remove one line from the open confirmation (a support add the store refused);
     returns false when nothing would be left to confirm */
  function confirmDropLine(title) {
    var left = 0;
    if (queuedConfirm) {
      queuedConfirm.lines = queuedConfirm.lines.filter(function (ln) { return ln.title !== title; });
      left += queuedConfirm.lines.length;
    }
    var c = $('#ft-confirm');
    if (c && !c.hidden) {
      $$('[data-confirm-lines] li', c).forEach(function (li) { var name = li.firstChild; if (name && name.textContent === title) li.remove(); });
      left += $$('[data-confirm-lines] li', c).length;
    }
    return left > 0;
  }
  var returnY = null;                            /* where the guest was scrolled before the pop-ups */
  /* checkout — every PROCEED TO CHECKOUT control anywhere (confirmation, cart
     drawer, cart page) goes straight to Shopify checkout. The controls are
     real links so they work instantly even without this script; the handler
     is the net for anything that is still a button. */
  function checkoutUrl() {
    var root = (window.FT.routes.root || '/').replace(/\/$/, '');
    return root + '/checkout';
  }
  function initCheckout() {
    on(doc, 'click', function (e) {
      var c = e.target.closest('[data-checkout]');
      if (!c) return;
      if (c.tagName === 'A' && c.getAttribute('href')) return;      /* the link handles itself */
      if (c.type === 'submit') return;                              /* the cart form handles itself */
      window.FT.go(checkoutUrl());
    });
    /* keep the drawer/confirmation links locale-correct */
    $$('a[data-checkout]').forEach(function (a) { a.setAttribute('href', checkoutUrl()); });
  }
  function initConfirm() {
    on($('#ft-confirm'), 'click', function (e) {
      if (e.target.closest('[data-confirm-return]')) {
        /* OTHER RESERVATIONS — close and land exactly where they were */
        confirmClose();
        var y = returnY; returnY = null;
        if (y != null && Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
        var resv = doc.getElementById('reservations');
        if (!resv) { scrollToId('reservations'); }
      }
    });
  }

  /* ---------------- cart ---------------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }
  function cartFetch() {
    return fetch(window.FT.routes.cartGet, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function cartAdd(items) {
    return fetch(window.FT.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    }).then(cartFetch);
  }
  /* set several variants at once — used to clear every Chephew line in one call */
  function cartUpdate(updates) {
    return fetch(window.FT.routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }
  /* one place every cart mutation reports to: header count, the Chephew chip,
     and the drawer if it happens to be open */
  function syncCart(cart) {
    if (!cart) return;
    if (typeof cart.item_count === 'number') updateCartCount(cart.item_count);
    chephSyncFromCart(cart);
    var d = $('#ft-drawer');
    if (d && !d.hidden) drawerRender(cart);
  }
  function errMessage(err) {
    return (err && (err.description || err.message)) ? String(err.description || err.message) : tOr('toast.err', 'SOMETHING SLIPPED · TRY AGAIN');
  }

  /* ---------------- chephew + offers ----------------
     Chephew Support is its own product. Every amount in the pop-up is one of
     its variants and adds straight to the cart as its own line the moment it
     is tapped. The chip on the Standing Room tab mirrors what the cart holds
     and REMOVE SUPPORT clears it. Adding a $5 entry opens the pop-up on its
     own; the held-seat confirmation waits behind it.

     Linking is belt and braces: the section links the product in Liquid and
     prints its variants into the tiles. If that came up empty (handle drift,
     picker not set, whatever), the script asks the storefront itself —
     /products/<handle>.js, then predictive search — and rebuilds the tiles
     from the real product. Whatever it finds is reported in the console. */
  var CHEPH_MODAL = 'ft-cheph-modal';
  var CHEPH_TAG = '[First Taste] Chephew Support:';
  var chephProductId = 0;
  var chephPending = null;                       /* { lines } while the pop-up follows a $5 entry */
  var chephInCart = { cents: 0, variantIds: [] };
  var chephReady = Promise.resolve(false);       /* resolves true once tiles carry real variant ids */
  var lastCart = null;

  function chephLinked() { return chephProductId > 0; }

  function chephSyncFromCart(cart) {
    if (cart) lastCart = cart;
    var items = (cart && cart.items) || [];
    var cents = 0, ids = [];
    if (chephProductId) {
      items.forEach(function (it) {
        if (it.product_id === chephProductId) {
          cents += (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
          ids.push(it.variant_id);
        }
      });
    }
    chephInCart = { cents: cents, variantIds: ids };
    refreshChephUI();
  }

  function refreshChephUI() {
    var chip = $('.ft-cheph');
    var state = $('[data-cheph-state]');
    var stateIn = $('[data-cheph-state-in]');
    var amount = $('[data-cheph-amount]');
    var clearRow = $('[data-cheph-clear-row]');
    var has = chephInCart.cents > 0;
    if (chip) chip.classList.toggle('is-in', has);
    if (state) state.hidden = has;
    if (stateIn) stateIn.hidden = !has;
    if (amount) { amount.hidden = !has; if (has) amount.textContent = '+ ' + window.FT.money(chephInCart.cents); }
    if (clearRow) clearRow.style.display = has ? 'inline' : 'none';
    $$('[data-cheph-opt]').forEach(function (o) {
      var vid = parseInt(o.getAttribute('data-variant-id'), 10) || 0;
      o.setAttribute('aria-pressed', vid && chephInCart.variantIds.indexOf(vid) !== -1 ? 'true' : 'false');
    });
  }

  /* the confirmation rises a beat after the pop-up starts to fade; the queued
     lines stay editable until they render (a refused add can still drop out) */
  var queuedConfirm = null;
  function confirmSoon(lines, kind, delay) {
    queuedConfirm = { lines: lines, kind: kind };
    setTimeout(function () {
      var q = queuedConfirm; queuedConfirm = null;
      if (q && q.lines.length) confirmShow(q.lines, q.kind);
    }, delay == null ? 160 : delay);
  }

  function fetchJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(url + ' → ' + r.status);
      return r.json();
    });
  }

  /* the tiles: do they already carry real variant ids? */
  function chephTilesLinked() {
    var opts = $$('[data-cheph-opt]');
    return opts.length > 0 && opts.every(function (o) { return parseInt(o.getAttribute('data-variant-id'), 10) > 0; });
  }

  /* rebuild the amount tiles from a product (as returned by /products/<handle>.js) */
  function chephHydrate(product) {
    var existing = $$('#' + CHEPH_MODAL + ' [data-cheph-opt]');
    var template = existing[0];
    var grid = template ? template.parentNode : null;
    if (!grid || !product || !product.variants || !product.variants.length) return false;
    var variants = product.variants.slice().sort(function (a, b) { return a.price - b.price; });
    var proto = template.cloneNode(true);
    proto.classList.remove('ft-cheph-opt--soldout', 'is-busy');
    proto.removeAttribute('disabled'); proto.removeAttribute('aria-disabled');
    var oldStamp = $('.ft-tier__stamp', proto); if (oldStamp) oldStamp.remove();
    /* replace only the tiles — never anything else sharing their parent */
    var anchor = doc.createComment('cheph-tiles');
    grid.insertBefore(anchor, template);
    existing.forEach(function (o) { o.remove(); });
    var frag = doc.createDocumentFragment();
    variants.forEach(function (v) {
      var tile = proto.cloneNode(true);
      tile.setAttribute('data-variant-id', String(v.id));
      tile.setAttribute('data-cents', String(v.price));
      tile.setAttribute('data-variant-title', v.title || '');
      tile.setAttribute('aria-pressed', 'false');
      var amt = $('.amt', tile); if (amt) amt.textContent = window.FT.money(v.price);
      if (v.available === false) {
        tile.classList.add('ft-cheph-opt--soldout');
        tile.disabled = true; tile.setAttribute('aria-disabled', 'true');
        var stamp = doc.createElement('span'); stamp.className = 'ft-tier__stamp'; stamp.setAttribute('aria-hidden', 'true');
        stamp.setAttribute('data-i18n', 'tier.soldout'); stamp.textContent = tOr('tier.soldout', 'SOLD OUT');
        tile.appendChild(stamp);
      }
      frag.appendChild(tile);
    });
    grid.insertBefore(frag, anchor);
    anchor.remove();
    chephProductId = product.id;
    var modal = doc.getElementById(CHEPH_MODAL);
    if (modal) { modal.setAttribute('data-chephew-product-id', String(product.id)); modal.setAttribute('data-chephew-handle', product.handle || ''); }
    return true;
  }

  /* ---------------- product linking, for every tab ----------------
     The theme links each tab's product in Liquid (picker → handle → title)
     and prints real variant ids into the controls. When any tab still has no
     ids, the script connects it here: /products/<handle>.js across the known
     handles, then predictive search across the known titles — then fills the
     tiers, prices and ADD bar from the real product. Nothing on this site
     "opens soon": a tap either adds to the cart or says plainly why not. */
  var OFFER_CONF = {
    standing: { handles: ['standing-room', 'standing', 'general-admission'], q: 'standing room', match: /standing|general\s*admission/i, name: 'Standing Room' },
    reserve:  { handles: ['reservation', 'reservations', 'seat-reservation', 'seat-reservations', 'table-reservation', 'table-reservations', 'reserve-your-seat'], q: 'reservation', match: /reserv|seat|table/i, name: 'Reservation' },
    bottle:   { handles: ['bottle-service', 'bottle', 'bottles'], q: 'bottle', match: /bottle/i, name: 'Bottle Service' },
    sections: { handles: ['sections', 'section'], q: 'section', match: /section/i, name: 'Sections' },
    diamond:  { handles: ['diamond-package', 'diamond'], q: 'diamond', match: /diamond/i, name: 'Diamond Package' },
    chephew:  { handles: ['chephew-support', 'chephew'], q: 'chephew', match: /chephew/i, name: 'Chephew Support' }
  };
  var offerReady = {};
  var PROD_TAG = '[First Taste] Products:';

  function productJSON(h) {
    var root = (window.FT.routes.root || '/').replace(/\/$/, '');
    return fetchJSON(root + '/products/' + encodeURIComponent(h) + '.js');
  }
  function discoverProduct(key) {
    var conf = OFFER_CONF[key];
    var root = (window.FT.routes.root || '/').replace(/\/$/, '');
    var suggest = window.FT.routes.suggest || (root + '/search/suggest');
    function bySuggest() {
      return fetchJSON(suggest + '.json?q=' + encodeURIComponent(conf.q) + '&resources[type]=product&resources[limit]=10')
        .then(function (res) {
          var found = (res && res.resources && res.resources.results && res.resources.results.products) || [];
          var best = found.filter(function (pr) { return conf.match.test(pr.title || '') || conf.match.test(pr.handle || ''); })[0];
          if (!best) throw new Error('predictive search found nothing matching "' + conf.q + '"');
          return productJSON(best.handle);
        });
    }
    function byHandles(i) {
      if (i >= conf.handles.length) return Promise.reject(new Error('no product at any known handle'));
      return productJSON(conf.handles[i]).catch(function () { return byHandles(i + 1); });
    }
    /* canonical handle first, then title search (catches any name), then the rest */
    return productJSON(conf.handles[0])
      .catch(function () { return bySuggest(); })
      .catch(function () { return byHandles(1); });
  }

  /* stamp / unstamp any control (tier chip or ADD bar) */
  function markSold(el, sold, cls) {
    if (!el) return;
    el.classList.toggle(cls, sold);
    el.disabled = sold;
    if (sold) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled');
    var stamp = $('.ft-tier__stamp', el);
    if (sold && !stamp) {
      stamp = doc.createElement('span');
      stamp.className = 'ft-tier__stamp'; stamp.setAttribute('aria-hidden', 'true');
      stamp.setAttribute('data-i18n', 'tier.soldout'); stamp.textContent = tOr('tier.soldout', 'SOLD OUT');
      el.appendChild(stamp);
    }
    if (!sold && stamp) stamp.remove();
  }

  /* pour a runtime-found product into its tab: tiers, prices, ADD bar, stamps */
  function applyOfferProduct(key, product) {
    var card = $('[data-offer="' + key + '"]');
    if (!card || !product || !product.variants || !product.variants.length) return false;
    var vs = product.variants.slice().sort(function (a, b) { return a.price - b.price; });
    var lo = vs[0], hi = vs[vs.length - 1];
    var addBtn = $('[data-add]', card);
    if (!addBtn) return false;
    if (product.handle) card.setAttribute('data-product-handle', product.handle);
    addBtn.setAttribute('data-title', product.title || OFFER_CONF[key].name);

    function fillTier(chip, v) {
      if (!chip) return;
      if (!v) { chip.style.display = 'none'; chip.setAttribute('aria-pressed', 'false'); return; }
      chip.style.display = '';
      chip.setAttribute('data-variant-id', String(v.id));
      chip.setAttribute('data-price', String(v.price));
      var amt = $('.ft-tier__amt', chip); if (amt) amt.textContent = window.FT.money(v.price);
      markSold(chip, v.available === false, 'ft-tier--soldout');
    }
    function pressTier(chips, ledger) {
      var live = chips.filter(function (c) { return c.style.display !== 'none' && !c.disabled; });
      if (!live.length) { markSold(addBtn, true, 'ft-addbar--soldout'); return; }
      markSold(addBtn, false, 'ft-addbar--soldout');
      var keep = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true' && live.indexOf(c) !== -1; })[0] || live[0];
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === keep ? 'true' : 'false'); });
      addBtn.setAttribute('data-variant-id', keep.getAttribute('data-variant-id'));
      addBtn.setAttribute('data-price', keep.getAttribute('data-price'));
      if (ledger) ledger.textContent = window.FT.money(parseInt(keep.getAttribute('data-price'), 10) || 0);
    }

    if (key === 'standing') {
      var sc = $$('[data-standing-tier]', card);
      sc.forEach(function (chip) {
        fillTier(chip, chip.getAttribute('data-standing-tier') === '0' ? hi : (vs.length > 1 ? lo : null));
      });
      pressTier(sc, null);
    } else if (key === 'bottle' || key === 'sections') {
      var attr = key === 'bottle' ? 'data-bottle-tier' : 'data-sections-tier';
      var chips = $$('[' + attr + ']', card);
      chips.forEach(function (chip) {
        fillTier(chip, chip.getAttribute(attr) === '0' ? lo : (vs.length > 1 ? hi : null));
      });
      pressTier(chips, $(key === 'bottle' ? '[data-bottle-price]' : '[data-sections-price]', card));
    } else {
      var v = vs.filter(function (x) { return x.available !== false; })[0] || vs[0];
      addBtn.setAttribute('data-variant-id', String(v.id));
      addBtn.setAttribute('data-price', String(v.price));
      var priceEl = $('.ft-card__price', card); if (priceEl) priceEl.textContent = window.FT.money(lo.price);
      markSold(addBtn, vs.every(function (x) { return x.available === false; }), 'ft-addbar--soldout');
    }
    return true;
  }

  /* does this tab still need a product? */
  function offerUnlinked(key) {
    if (key === 'chephew') return !(chephProductId && chephTilesLinked());
    var card = $('[data-offer="' + key + '"]');
    if (!card) return false;
    var addBtn = $('[data-add]', card);
    return !!addBtn && !(parseInt(addBtn.getAttribute('data-variant-id'), 10) > 0);
  }

  /* one promise per tab; resolves true once its controls carry real variant ids */
  function ensureOffer(key) {
    if (offerReady[key]) return offerReady[key];
    var conf = OFFER_CONF[key];
    if (!conf) return Promise.resolve(false);
    if (!offerUnlinked(key)) { offerReady[key] = Promise.resolve(true); return offerReady[key]; }
    offerReady[key] = discoverProduct(key).then(function (product) {
      var ok = key === 'chephew' ? chephHydrate(product) : applyOfferProduct(key, product);
      if (!ok) throw new Error('product "' + (product && product.title) + '" has no variants');
      console.info(PROD_TAG, conf.name + ' connected at runtime to product #' + product.id + ' "' + product.title + '" (/products/' + product.handle + '). Set the picker in Customize → Home → Reservations to link it permanently.');
      logOfferVariants(key, product);
      if (key === 'chephew') { chephTitle = product.title || chephTitle; if (lastCart) chephSyncFromCart(lastCart); }
      return true;
    }).catch(function (err) {
      console.error(PROD_TAG, conf.name + ' NOT CONNECTED — no product found on the storefront.', err && err.message ? err.message : err,
        '\nFix: Products → make sure a product for ' + conf.name + ' exists, is ACTIVE, and is published to the Online Store sales channel — or pick it under Customize → Home → Reservations.');
      return false;
    });
    return offerReady[key];
  }

  /* say, per variant, what Shopify itself reports — so a stamped amount is
     never a mystery */
  function logOfferVariants(key, product) {
    var parts = product.variants.map(function (v) {
      var t = v.title && v.title !== 'Default Title' ? '"' + v.title + '" ' : '';
      return t + window.FT.money(v.price) + (v.available === false ? ' — SOLD OUT' : ' — available');
    });
    console.info(PROD_TAG, OFFER_CONF[key].name + ': ' + parts.join(' · ') + '.');
    if (product.variants.some(function (v) { return v.available === false; })) {
      console.info(PROD_TAG, 'SOLD OUT above is Shopify\'s own answer for "' + product.title + '". If an amount should be purchasable: Admin → Products → ' + product.title + ' → that variant → untick "Track quantity" (unlimited), or tick "Continue selling when out of stock".');
    }
  }

  /* re-read a tab's product straight from the storefront and re-apply it —
     availability, prices, variant ids. Runs at load for every tab (so a
     cached page with stale SOLD OUT stamps corrects itself) and again after
     the cart refuses an add. */
  function refreshOfferFromStore(key, handle) {
    if (!handle) return Promise.resolve(false);
    return productJSON(handle).then(function (product) {
      var ok = key === 'chephew' ? chephHydrate(product) : applyOfferProduct(key, product);
      if (ok) {
        logOfferVariants(key, product);
        if (key === 'chephew') { if (lastCart) chephSyncFromCart(lastCart); else refreshChephUI(); }
      }
      return ok;
    }).catch(function () { return false; });
  }
  function offerHandle(key) {
    if (key === 'chephew') {
      var modal = doc.getElementById(CHEPH_MODAL);
      return modal ? modal.getAttribute('data-chephew-handle') : '';
    }
    var card = $('[data-offer="' + key + '"]');
    return card ? card.getAttribute('data-product-handle') : '';
  }

  var chephTitle = 'Chephew Support';
  function offersInit() {
    var modal = doc.getElementById(CHEPH_MODAL);
    if (modal) {
      chephProductId = parseInt(modal.getAttribute('data-chephew-product-id'), 10) || 0;
      try {
        var node = $('[data-cheph-product]', modal);
        var data = node ? JSON.parse(node.textContent || 'null') : null;
        if (data && data.title) chephTitle = data.title;
      } catch (e) { /* the tiles still work without it */ }
    }
    ['standing', 'reserve', 'bottle', 'sections', 'diamond', 'chephew'].forEach(function (key) {
      if (!offerUnlinked(key)) {
        offerReady[key] = Promise.resolve(true);
        console.info(PROD_TAG, OFFER_CONF[key].name + ' linked by the theme.');
        /* the page may be cached — confirm prices and availability against the live product */
        refreshOfferFromStore(key, offerHandle(key));
      } else {
        console.warn(PROD_TAG, OFFER_CONF[key].name + ' not linked by the theme — asking the storefront…');
        ensureOffer(key);
      }
    });
    chephReady = offerReady.chephew || Promise.resolve(false);
  }

  function initOffers() {
    offersInit();

    /* the pop-up knows whether it opened by itself (after a $5 entry) or from the chip */
    on(doc, 'ft:modalopen', function (e) {
      if (!e.detail || e.detail.id !== CHEPH_MODAL) return;
      var held = $('[data-cheph-held]', e.detail.modal);
      if (held) held.hidden = !chephPending;
    });
    /* however it closes after a $5 entry — an amount, MAYBE LATER, the veil,
       Escape — the held-seat confirmation follows with everything that landed */
    on(doc, 'ft:modalclose', function (e) {
      if (!e.detail || e.detail.id !== CHEPH_MODAL || !chephPending) return;
      var pending = chephPending; chephPending = null;
      confirmSoon(pending.lines, 'seat');
    });

    /* the amounts — tap one, it is in the cart. Delegated, so tiles rebuilt
       at runtime work exactly like the ones the theme printed. */
    on(doc.getElementById(CHEPH_MODAL), 'click', function (e) {
      var opt = e.target.closest('[data-cheph-opt]');
      if (!opt || opt.disabled || opt.classList.contains('is-busy')) return;
      var vid = parseInt(opt.getAttribute('data-variant-id'), 10) || 0;
      var cents = parseInt(opt.getAttribute('data-cents'), 10) || 0;
      if (!vid) {
        /* the runtime link may still be in flight — wait for it, then act */
        opt.classList.add('is-busy');
        var lateDone = false;
        var lateTimer = setTimeout(function () { lateDone = true; opt.classList.remove('is-busy'); modalClose(); toast(tOr('toast.unavailable', "THIS ISN'T AVAILABLE RIGHT NOW · PLEASE TRY AGAIN")); }, 6000);
        ensureOffer('chephew').then(function (ok) {
          if (lateDone) return;
          clearTimeout(lateTimer);
          opt.classList.remove('is-busy');
          if (!ok) {
            console.error(CHEPH_TAG, 'tap could not be completed — no Chephew Support product on the storefront.');
            modalClose();
            toast(tOr('toast.unavailable', "THIS ISN'T AVAILABLE RIGHT NOW · PLEASE TRY AGAIN"));
            return;
          }
          /* the grid was rebuilt from the real product; retap the same amount if it exists */
          var again = $('#' + CHEPH_MODAL + ' [data-cheph-opt][data-cents="' + cents + '"]');
          if (again && parseInt(again.getAttribute('data-variant-id'), 10) > 0 && !again.disabled) again.click();
          /* otherwise the pop-up now shows the real amounts — let the guest choose */
        });
        return;
      }
      var line = { title: chephTitle, price: window.FT.money(cents) };
      opt.classList.add('is-busy');
      opt.setAttribute('aria-pressed', 'true');
      if (chephPending) {
        chephPending.lines.push(line);
        modalClose();                              /* → ft:modalclose shows the held-seat confirmation */
      } else {
        modalClose();
        confirmSoon([line], 'cheph');
      }
      toast(tOr('toast.cheph', 'CHEPHEW SUPPORT ADDED') + ' · ' + window.FT.money(cents));
      cartAdd([{ id: vid, quantity: 1 }]).then(function (cart) {
        opt.classList.remove('is-busy');
        console.info(CHEPH_TAG, 'variant #' + vid + ' (' + window.FT.money(cents) + ') is in the cart. Cart now holds ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + '.');
        syncCart(cart);
      }).catch(function (err) {
        opt.classList.remove('is-busy');
        console.error(CHEPH_TAG, 'the store refused variant #' + vid + ':', err);
        refreshOfferFromStore('chephew', offerHandle('chephew'));
        refreshChephUI();
        /* the seat (if any) did land — keep its confirmation, drop the support line */
        if (!confirmDropLine(chephTitle)) confirmClose();
        toast(errMessage(err));
      });
    });

    /* REMOVE SUPPORT on the chip — clears every Chephew line from the cart */
    $$('[data-cheph-clear]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.stopPropagation();
        if (btn.disabled) return;
        btn.disabled = true;
        cartFetch().then(function (cart) {
          var updates = {};
          ((cart && cart.items) || []).forEach(function (it) {
            if (it.product_id === chephProductId) updates[String(it.variant_id)] = 0;
          });
          if (!Object.keys(updates).length) return cart;
          return cartUpdate(updates);
        }).then(function (cart) {
          btn.disabled = false;
          syncCart(cart);
          toast(tOr('toast.removed', 'SUPPORT REMOVED'));
        }).catch(function (err) {
          btn.disabled = false;
          toast(errMessage(err));
        });
      });
    });

    /* bottle tier chips — the gold image only loads once Gold Loot is wanted */
    var bottleCard = $('[data-offer="bottle"]');
    if (bottleCard) {
      var chips = $$('[data-bottle-tier]', bottleCard);
      var imgwrap = $('[data-bottle-imgs]', bottleCard);
      var priceEl = $('[data-bottle-price]', bottleCard);
      var addBtn = $('[data-bottle-add]', bottleCard);
      var altImg = imgwrap ? $('.img-alt', imgwrap) : null;
      function loadAlt() {
        if (altImg && !altImg.getAttribute('src') && altImg.getAttribute('data-src')) {
          altImg.src = altImg.getAttribute('data-src');
          altImg.removeAttribute('data-src');
        }
      }
      chips.forEach(function (chip) {
        var isGold = chip.getAttribute('data-bottle-tier') === '1';
        if (isGold) { on(chip, 'pointerenter', loadAlt); on(chip, 'focus', loadAlt); }
        on(chip, 'click', function () {
          if (chip.disabled) return;
          chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          if (isGold) loadAlt();
          if (imgwrap) imgwrap.classList.toggle('show-alt', isGold);
          var cents = parseInt(chip.getAttribute('data-price'), 10) || 0;
          if (priceEl) priceEl.textContent = window.FT.money(cents);
          if (addBtn) {
            addBtn.setAttribute('data-variant-id', chip.getAttribute('data-variant-id') || '');
            addBtn.setAttribute('data-price', String(cents));
          }
        });
      });
    }

    /* standing room admission tiers — $1 entry / $5 entry */
    var standingCard = $('[data-offer="standing"]');
    if (standingCard) {
      var sChips = $$('[data-standing-tier]', standingCard);
      var sAddBtn = $('[data-standing-add]', standingCard);
      sChips.forEach(function (chip) {
        on(chip, 'click', function () {
          if (chip.disabled) return;
          sChips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          var cents = parseInt(chip.getAttribute('data-price'), 10) || 0;
          if (sAddBtn) {
            sAddBtn.setAttribute('data-variant-id', chip.getAttribute('data-variant-id') || '');
            sAddBtn.setAttribute('data-price', String(cents));
          }
        });
      });
    }

    /* sections tiers — $3,000 section / $5,000 premier */
    var sectionsCard = $('[data-offer="sections"]');
    if (sectionsCard) {
      var scChips = $$('[data-sections-tier]', sectionsCard);
      var scPriceEl = $('[data-sections-price]', sectionsCard);
      var scAddBtn = $('[data-sections-add]', sectionsCard);
      scChips.forEach(function (chip) {
        on(chip, 'click', function () {
          if (chip.disabled) return;
          scChips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', 'true');
          var cents = parseInt(chip.getAttribute('data-price'), 10) || 0;
          if (scPriceEl) scPriceEl.textContent = window.FT.money(cents);
          if (scAddBtn) {
            scAddBtn.setAttribute('data-variant-id', chip.getAttribute('data-variant-id') || '');
            scAddBtn.setAttribute('data-price', String(cents));
          }
        });
      });
    }

    /* + add buttons — reservation prompts for a kitchen note first */
    var dietTarget = null;
    function performAdd(btn, note) {
      if (btn.classList.contains('is-busy') || btn.disabled) return;
      var vid = btn.getAttribute('data-variant-id');
      var title = btn.getAttribute('data-title') || '';
      var cents = parseInt(btn.getAttribute('data-price') || '0', 10);
      var card = btn.closest('[data-offer]');
      var isStanding = !!(card && card.getAttribute('data-offer') === 'standing');

      var lines = [{ title: title, price: window.FT.money(cents) }];
      var items = [];
      if (vid) {
        var item = { id: parseInt(vid, 10), quantity: 1 };
        if (note) item.properties = { 'Dietary Restrictions': note };
        items.push(item);
      }

      function flash() {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1300);
      }

      if (!items.length) {
        /* no variant yet — the runtime link may still be in flight. Wait for
           it, refresh the button's target, and complete the purchase. */
        var key = card ? card.getAttribute('data-offer') : '';
        if (!OFFER_CONF[key]) { toast(tOr('toast.unavailable', "THIS ISN'T AVAILABLE RIGHT NOW · PLEASE TRY AGAIN")); return; }
        btn.classList.add('is-busy');
        var lateDone = false;
        var lateTimer = setTimeout(function () {
          lateDone = true;
          btn.classList.remove('is-busy');
          console.error(PROD_TAG, OFFER_CONF[key].name + ' — ADD pressed but the product link timed out.');
          toast(tOr('toast.unavailable', "THIS ISN'T AVAILABLE RIGHT NOW · PLEASE TRY AGAIN"));
        }, 6000);
        ensureOffer(key).then(function (ok) {
          if (lateDone) return;
          clearTimeout(lateTimer);
          btn.classList.remove('is-busy');
          if (ok && parseInt(btn.getAttribute('data-variant-id'), 10) > 0 && !btn.disabled) {
            performAdd(btn, note);
          } else if (!btn.disabled) {
            console.error(PROD_TAG, OFFER_CONF[key].name + ' — ADD pressed but no product is connected on the storefront.');
            toast(tOr('toast.unavailable', "THIS ISN'T AVAILABLE RIGHT NOW · PLEASE TRY AGAIN"));
          }
          /* a disabled button means the runtime link found the product sold out — the stamp says so */
        });
        return;
      }

      /* remember where the guest was — OTHER RESERVATIONS brings them back here */
      returnY = window.scrollY;

      /* a $5 entry opens Chephew Support on its own — unless support is
         already in the cart, or no Chephew product is connected */
      var wantsPrompt = false;
      if (isStanding && chephInCart.cents === 0) {
        var pressed = $('[data-standing-tier][aria-pressed="true"]', card);
        wantsPrompt = !!(pressed && pressed.hasAttribute('data-cheph-prompt'));
      }

      /* optimistic: confirm instantly, sync with the store in the background */
      btn.classList.add('is-busy');
      flash();
      var opened = false;
      function open(prompt) {
        if (opened) return; opened = true;
        if (prompt) { chephPending = { lines: lines }; modalOpen(CHEPH_MODAL, btn); }
        else confirmShow(lines, 'seat');
      }
      if (wantsPrompt && chephLinked()) open(true);
      else if (wantsPrompt) {
        /* the runtime link may still be in flight — give it a beat, then decide */
        var waited = false;
        var timer = setTimeout(function () { waited = true; open(false); }, 900);
        chephReady.then(function (ok) { clearTimeout(timer); if (!waited) open(!!ok && chephLinked()); });
      } else open(false);

      cartAdd(items).then(function (cart) {
        btn.classList.remove('is-busy');
        syncCart(cart);
      }).catch(function (err) {
        btn.classList.remove('is-busy');
        chephPending = null;
        modalClose();
        confirmClose();
        toast(errMessage(err));
        /* the store said no — pull the live product so the stamps tell the truth */
        var k = card ? card.getAttribute('data-offer') : '';
        if (k) refreshOfferFromStore(k, offerHandle(k));
      });
    }
    $$('[data-add]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (btn.classList.contains('is-busy') || btn.disabled) return;
        if (btn.hasAttribute('data-note-prompt') && $('#ft-diet-modal')) {
          dietTarget = btn;
          modalOpen('ft-diet-modal', btn);
          setTimeout(function () { var ta = $('[data-diet-input]'); if (ta) ta.focus({ preventScroll: true }); }, 120);
          return;
        }
        performAdd(btn, null);
      });
    });
    on($('[data-diet-confirm]'), 'click', function () {
      var ta = $('[data-diet-input]');
      var note = ta ? ta.value.trim().slice(0, 240) : '';
      modalClose();
      if (dietTarget) performAdd(dietTarget, note || null);
      if (ta) ta.value = '';
      dietTarget = null;
    });
    on($('[data-diet-skip]'), 'click', function () {
      var ta = $('[data-diet-input]');
      modalClose();
      if (dietTarget) performAdd(dietTarget, null);
      if (ta) ta.value = '';
      dietTarget = null;
    });

    refreshChephUI();
  }


  /* ---------------- floating return-to-reservations ---------------- */
  function initReturn() {
    var btn = $('#ft-return');
    if (!btn) return;
    var target = doc.getElementById('reservations');
    var ticking = false;
    function evaluate() {
      ticking = false;
      var show;
      if (!target) {
        show = true;
      } else {
        var r = target.getBoundingClientRect();
        show = (r.width === 0 && r.height === 0) || r.bottom < window.innerHeight * 0.35;
      }
      btn.hidden = false;
      btn.classList.toggle('is-in', !!show);
    }
    on(window, 'scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(evaluate); }
    }, { passive: true });
    evaluate();
    if (!target) setTimeout(evaluate, 400);
  }

  /* ---------------- cart drawer ---------------- */
  function drawerEls() {
    var d = $('#ft-drawer');
    if (!d) return null;
    return { root: d, lines: $('[data-drawer-lines]', d), empty: $('[data-drawer-empty]', d),
             foot: $('[data-drawer-foot]', d), total: $('[data-drawer-total]', d), count: $('[data-drawer-count]', d) };
  }
  function drawerRender(cart) {
    var els = drawerEls();
    if (!els) return;
    var items = (cart && cart.items) || [];
    els.count.textContent = cart ? cart.item_count : 0;
    if (!items.length) {
      els.lines.textContent = '';
      els.empty.hidden = false; els.foot.hidden = true;
      return;
    }
    els.empty.hidden = true; els.foot.hidden = false;
    els.total.textContent = window.FT.money(cart.total_price);
    els.lines.textContent = '';
    items.forEach(function (it, idx) {
      var li = doc.createElement('li'); li.className = 'ft-mrow';
      var imwrap = doc.createElement('div'); imwrap.className = 'ft-mrow__img';
      var im = doc.createElement('img');
      im.alt = ''; im.loading = 'lazy';
      if (it.image) { im.src = it.image; }
      else if (window.FT.assets && window.FT.assets.circle) { im.src = window.FT.assets.circle; im.style.padding = '8px'; im.style.aspectRatio = '1'; im.style.objectFit = 'contain'; }
      imwrap.appendChild(im);
      var mid = doc.createElement('div');
      var name = doc.createElement('p'); name.className = 'ft-mrow__name'; name.textContent = it.product_title || it.title;
      mid.appendChild(name);
      if (it.variant_title && String(it.variant_title).indexOf('Default') === -1) {
        var vr = doc.createElement('p'); vr.className = 'ft-mrow__var'; vr.textContent = it.variant_title; mid.appendChild(vr);
      }
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          var val = it.properties[k];
          if (!val || String(k).charAt(0) === '_') return;
          var note = doc.createElement('p'); note.className = 'ft-mrow__note'; note.textContent = String(val);
          mid.appendChild(note);
        });
      }
      var rm = doc.createElement('button'); rm.type = 'button'; rm.className = 'ft-mrow__rm';
      rm.textContent = tOr('cart.remove', 'REMOVE');
      rm.addEventListener('click', function () { drawerChange(idx + 1, 0); });
      mid.appendChild(rm);
      var right = doc.createElement('div'); right.className = 'ft-mrow__right';
      var price = doc.createElement('span'); price.className = 'ft-mrow__price';
      price.textContent = window.FT.money(it.final_line_price != null ? it.final_line_price : it.line_price);
      var qty = doc.createElement('div'); qty.className = 'ft-qty';
      var minus = doc.createElement('button'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease'); minus.textContent = '−';
      var input = doc.createElement('input'); input.type = 'text'; input.readOnly = true; input.value = it.quantity; input.setAttribute('aria-label', 'Quantity');
      var plus = doc.createElement('button'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase'); plus.textContent = '+';
      minus.addEventListener('click', function () { drawerChange(idx + 1, it.quantity - 1); });
      plus.addEventListener('click', function () { drawerChange(idx + 1, it.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);
      right.appendChild(price); right.appendChild(qty);
      li.appendChild(imwrap); li.appendChild(mid); li.appendChild(right);
      els.lines.appendChild(li);
    });
  }
  function drawerFetch() { return cartFetch(); }
  function drawerChange(line, qty) {
    fetch(window.FT.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    }).then(function (cart) {
      drawerRender(cart);
      syncCart(cart);
    }).catch(function (err) { toast(errMessage(err)); });
  }
  function drawerOpen() {
    var els = drawerEls();
    if (!els) return;
    doc.dispatchEvent(new CustomEvent('ft:overlay'));
    confirmClose();
    els.root.hidden = false;
    requestAnimationFrame(function () { if (!els.root.hidden) els.root.classList.add('is-open'); });
    doc.documentElement.style.overflow = 'hidden';
    drawerFetch().then(function (cart) { drawerRender(cart); chephSyncFromCart(cart); }).catch(function () { drawerRender(null); });
    var panel = $('.ft-drawer__panel', els.root);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 80);
  }
  function drawerClose() {
    var els = drawerEls();
    if (!els || els.root.hidden) return;
    els.root.classList.remove('is-open');
    doc.documentElement.style.overflow = '';
    setTimeout(function () { els.root.hidden = true; }, 620);
  }
  function initDrawer() {
    on(doc, 'click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) { e.preventDefault(); drawerOpen(); return; }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) {
        drawerClose();
        var sc = closer.closest('[data-scrollto]');
        if (sc) setTimeout(function () { scrollToId(sc.getAttribute('data-scrollto')); }, 300);
      }
    });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape') drawerClose(); });
  }

  /* ---------------- cart page ---------------- */
  function initCartPage() {
    var form = $('#ft-cart-form');
    if (!form) return;

    function change(line, qty) {
      return fetch(window.FT.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
    function refresh() { window.location.reload(); }

    $$('.ft-qty', form).forEach(function (q) {
      var input = $('input', q);
      var line = parseInt(input.getAttribute('data-line-qty'), 10);
      on($('[data-qty-minus]', q), 'click', function () {
        var v = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        change(line, v).then(refresh);
      });
      on($('[data-qty-plus]', q), 'click', function () {
        var v = (parseInt(input.value, 10) || 0) + 1;
        input.value = v;
        change(line, v).then(refresh);
      });
      on(input, 'change', function () {
        var v = Math.max(0, parseInt(input.value, 10) || 0);
        change(line, v).then(refresh);
      });
    });
    $$('[data-remove-line]', form).forEach(function (btn) {
      on(btn, 'click', function () {
        change(parseInt(btn.getAttribute('data-remove-line'), 10), 0).then(refresh);
      });
    });
  }

  /* ---------------- product page ---------------- */
  function initProduct() {
    var sel = $('[data-variant-select]');
    if (!sel) return;
    var priceEl = $('[data-product-price]');
    on(sel, 'change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (priceEl && opt) priceEl.textContent = opt.getAttribute('data-price') || priceEl.textContent;
    });
  }

  /* ---------------- dust ---------------- */
  function initDust() {
    var canvas = $('#ft-dust');
    if (!canvas || reduceMotion) return;
    if (doc.body.getAttribute('data-dust') !== 'true') return;
    if (window.innerWidth < 760) { canvas.remove(); return; }
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var density = Math.min(90, parseInt(doc.body.getAttribute('data-dust-density'), 10) || 40);
    var motes = [];
    var W, H, raf;
    function size() {
      W = canvas.width = Math.floor(window.innerWidth * devicePixelRatio / 2);
      H = canvas.height = Math.floor(window.innerHeight * devicePixelRatio / 2);
    }
    function seed() {
      motes = [];
      var n = Math.round(density * (window.innerWidth / 1440));
      for (var i = 0; i < n; i++) {
        motes.push({
          x: Math.random() * W, y: Math.random() * H,
          r: 0.4 + Math.random() * 1.3,
          vy: 0.03 + Math.random() * 0.12,
          vx: (Math.random() - 0.5) * 0.05,
          ph: Math.random() * Math.PI * 2,
          a: 0.12 + Math.random() * 0.35
        });
      }
    }
    var tPrev = 0;
    function frame(tNow) {
      raf = requestAnimationFrame(frame);
      if (tNow - tPrev < 33) return;
      tPrev = tNow;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < motes.length; i++) {
        var m = motes[i];
        m.y -= m.vy; m.x += m.vx + Math.sin(tNow / 4200 + m.ph) * 0.05;
        if (m.y < -4) { m.y = H + 4; m.x = Math.random() * W; }
        if (m.x < -4) m.x = W + 4; else if (m.x > W + 4) m.x = -4;
        var tw = 0.6 + 0.4 * Math.sin(tNow / 900 + m.ph * 3);
        ctx.beginPath();
        ctx.arc(m.x, m.y, m.r, 0, 6.2832);
        ctx.fillStyle = 'rgba(226, 185, 129,' + (m.a * tw).toFixed(3) + ')';
        ctx.fill();
      }
    }
    size(); seed();
    raf = requestAnimationFrame(frame);
    var rT;
    on(window, 'resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () { size(); seed(); }, 180);
    }, { passive: true });
    on(doc, 'visibilitychange', function () {
      if (doc.hidden) cancelAnimationFrame(raf);
      else raf = requestAnimationFrame(frame);
    });
  }

  /* warm the cart endpoint once at idle — the first ADD then rides a
     hot connection and primed cache instead of a cold handshake */
  function warmCart() {
    var go = function () {
      try {
        fetch(window.FT.routes.cartGet, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { if (cart && typeof cart.item_count === 'number') {
            $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            chephSyncFromCart(cart);
          } })
          .catch(function () {});
      } catch (e) {}
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 });
    else setTimeout(go, 1200);
  }

  /* ---------------- boot ---------------- */
  function boot() {
    [initZoomGuard, initLang, initHeader, initScrollLinks, initReveals, initCountdown, initModals,
     initCheckout, initConfirm, initDrawer, initReturn, initOffers, initCartPage, initProduct, initDust, warmCart]
      .forEach(function (init) {
        try { init(); } catch (err) { console.error('[First Taste] ' + (init.name || 'init') + ' failed:', err); }
      });
  }
  if (doc.readyState === 'loading') on(doc, 'DOMContentLoaded', boot);
  else boot();
})();
